var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockConfident = function SvgClockConfident(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003A4F",
    stroke: "#fff",
    strokeWidth: 0.25,
    d: "m15.443 16.393-2.512-4.004V5.68h-1.704v7.2l2.775 4.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#003A4F",
    stroke: "#fff",
    strokeWidth: 0.25,
    d: "M5.861 21.266c.521.392 1.08.73 1.668 1.011a8.7 8.7 0 0 0 3.975.945 13.5 13.5 0 0 0 6.886-2.215c3.064-2.298 4.466-5.347 4.055-8.823a11 11 0 0 0-.133-1.606 6.6 6.6 0 0 0-.254-1.47c-1.23-4.255-4.917-7.562-8.967-8.042C7.943.456 2.757 4.11 1.307 9.377q-.195.716-.292 1.451a12.36 12.36 0 0 0 4.845 10.44zm-3.15-10.26q.081-.596.24-1.175a9.65 9.65 0 0 1 8.989-7.124q.474 0 .945.056c3.387.4 6.484 3.206 7.528 6.82.11.384.177.78.2 1.179q.115.736.12 1.483l.007.1c.356 2.893-.781 5.349-3.307 7.25-3.462 2.077-6.537 2.465-9.158 1.15a8.3 8.3 0 0 1-1.4-.848 10.73 10.73 0 0 1-4.17-8.892z"
  })));
};
export default SvgClockConfident;